import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import { axiosHelper } from './helpers/axios';
import VueMatomo from 'vue-matomo';

const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(axiosHelper, { apiUrl: process.env.VUE_APP_API_URL, store });

app.use(VueMatomo, {
  host: process.env.VUE_APP_MATOMO_TRACKER_URL,
  siteId: process.env.VUE_APP_MATOMO_SITE_ID,
  router,
  enableLinkTracking: true,
});
window._paq = window._paq || [];
window._paq.push(['trackPageView']);

app.mount('#app');
